var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"text-right pa-1 text-break font-weight-medium"},[_vm._v(_vm._s(_vm.titulo)+":")]),_c('v-col',{staticClass:"pa-1 text-break"},[_vm._v(_vm._s(_vm.valor))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }